const config = {
  PASSWORD_MIN_LENGTH: 8
};

export default config;
